import { combineReducers } from 'redux';
import { ideaPositionDetails } from 'modules/IdeaPositionDetailsModal/reducer';
import orderSubmitModal from 'components/OrderSubmitModal/reducer';
import orderSubmittedModal from 'components/OrderSubmittedModal/reducer';
import modalContainer from 'components/ModalContainer/reducers';
import stockFilters from 'components/StockFilters/reducer';
import sellSubmittedModal from 'components/SellSubmittedModal/reducer';
import { stockPositionDetails } from 'modules/StockPositionDetailsModal/reducer';
import { loginWith2FARecomendation } from './loginWith2FARecomendation';

export default combineReducers({
  orderSubmitModal,
  orderSubmittedModal,
  modalContainer,
  sellSubmittedModal,
  stockFilters,
  ideaPositionDetails,
  stockPositionDetails,
  loginWith2FARecomendation,
});
